export default __webpack_public_path__ + "static/media/buttonClick.644fad82.mp3";